import { makeStyles } from "tss-react/mui";
import { Box, Typography } from "@mui/material";

export const EmptyMessageView = ({
  title,
  subtitle,
}: EmptyMessageViewProps) => {
  const { classes, theme } = useStyles();
  return (
    <Box className={classes.container}>
      <Typography variant="HD4" textAlign="center">
        {title}
      </Typography>
      <Typography color={theme.palette.grey.medium} textAlign="center">
        {subtitle}
      </Typography>
    </Box>
  );
};

type EmptyMessageViewProps = {
  title: string;
  subtitle: string;
};

const useStyles = makeStyles()((theme) => ({
  container: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    minHeight: 300,
    gap: theme.spacing(1),
  },
}));
